import { DeleteRounded, ExpandMore, SearchRounded } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, IconButton, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useWatch, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { IGetCustomersParams } from "../../../../api/services";
import DialogSearchCustomer from "../../../../components/DialogSearchCustomer";
import { FormTextField } from "../../../../components/fields";
import useDialog from "../../../../hooks/useDialog";
import { ICustomer } from "../../../../types";
import { accordionExpandedState } from "../../recoil";
import { IFormValues } from "../../types";

const AdditionalDriversDetails = () => {

    const { t } = useTranslation('booking');

    const [additionalDriversExpanded, setAdditionalDriversExpanded] = useRecoilState(accordionExpandedState('additionalDrivers'));

    const formContext = useFormContext<IFormValues>();

    const additionalDrivers = useWatch<IFormValues, 'additionalDrivers'>({
        name: 'additionalDrivers'
    });

    const searchDialog = useDialog();

    const [additionalDriverIndex, setAdditionalDriverIndex] = useState<number | undefined>();
    const [driverFilter, setDriverFilter] = useState<IGetCustomersParams['filters'] | null>(null);

    const setAdditionalDriverFilter = useCallback((index: number) => {
        setAdditionalDriverIndex(index);
        console.log('index: ', index);
        const additionalDriver = formContext.getValues(`additionalDrivers.${index}`);
        setDriverFilter({
            firstName: additionalDriver.name,
            lastName: additionalDriver.surname,
            email: additionalDriver.email,
            partnerType: '1'
        });
        searchDialog.handleShow();
    }, []);
    const handleCustomerSelected = useCallback((selectedCustomer: ICustomer) => {
        if (additionalDriverIndex === undefined) {
            return;
        };
        console.log('additionalDriverIndex: ', additionalDriverIndex);
        formContext.setValue(`additionalDrivers.${additionalDriverIndex}.id`, selectedCustomer.customerId);
        formContext.setValue(`additionalDrivers.${additionalDriverIndex}.name`, selectedCustomer.firstName);
        formContext.setValue(`additionalDrivers.${additionalDriverIndex}.surname`, selectedCustomer.lastName);
        formContext.setValue(`additionalDrivers.${additionalDriverIndex}.email`, selectedCustomer.email);
    }, [additionalDriverIndex]);
    const handleDeleteClick = useCallback((i: number) => {
        formContext.setValue(`additionalDrivers.${i}`, {
            id: '',
            name: '',
            surname: '',
            email: ''
        })
    }, []);

    return (
        <>
            <DialogSearchCustomer
                section={'additionalDriver'}
                open={searchDialog.open}
                onClose={searchDialog.handleClose}
                onCustomerSelected={handleCustomerSelected}
                customersFilter={driverFilter}
            />
            <Accordion expanded={additionalDriversExpanded} onChange={(e, expanded) => setAdditionalDriversExpanded(expanded)}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h5">
                        {t('label.additionalDriversDetails')}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        {additionalDrivers
                            .map((ad, i) => (
                                <Grid key={i} item container rowSpacing={1} columnSpacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <FormTextField
                                            name={`additionalDrivers.${i}.name`}
                                            label={t("label.firstName")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormTextField
                                            name={`additionalDrivers.${i}.surname`}
                                            label={t("label.lastName")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormTextField
                                            name={`additionalDrivers.${i}.email`}
                                            label={t("label.email")}
                                        />
                                    </Grid>
                                    <Grid item container xs={12} sm={6} justifyContent="end" alignItems="end">
                                        <IconButton onClick={() => setAdditionalDriverFilter(i)}>
                                            <SearchRounded />
                                        </IconButton>
                                        <IconButton onClick={() => handleDeleteClick(i)}>
                                            <DeleteRounded fontSize="small" />
                                        </IconButton>
                                    </Grid>
                                    {
                                        i !== additionalDrivers.length -1 &&
                                        <Divider orientation={"horizontal"}  style={{width:'100%'}} sx={{mt: 4, mb: 1, marginLeft: '12px'}} flexItem />
                                    }
                                </Grid>
                            ))}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default AdditionalDriversDetails;
